import en from '../assets/i18n/en.json';
import pt from '../assets/i18n/pt.json';
import { getUser } from './user';

const handleLanguage = (language, key) => {
    if (language) {
        switch (language) {
            case 'en':
                return en[key];
            case 'pt':
                return pt[key];
            default:
                return false;
        }
    } else {
        return en[key];
    }
};

export function translate(key, labelDefault = false) {
    const userLanguage = getUser()?.language;

    const browserLanguage =
        userLanguage || navigator.language || navigator.userLanguage;

    let language = 'en';
    if (browserLanguage.includes('pt')) {
        language = 'pt';
    }

    const defaultTranslation = handleLanguage(language, key);

    if (labelDefault) return defaultTranslation;

    const storagedOverwriteTranslations = localStorage.getItem(
        'overwriteTranslations',
    );

    if (storagedOverwriteTranslations) {
        const overwriteTranslations = JSON.parse(storagedOverwriteTranslations);
        const hasTranslation = overwriteTranslations.find(
            overwriteTranslation => {
                return overwriteTranslation?.label === key;
            },
        );

        return hasTranslation
            ? hasTranslation[language] || defaultTranslation
            : defaultTranslation;
    } else {
        return defaultTranslation;
    }
}
